module.exports = __webpack_public_path__ + "img/0x71DE20e0C4616E7fcBfDD3f875d568492cBE4739.d9fda216.png";